<template>
  <div class="clerk-info">
    <div class="wrap">
      <div class="box">
        <el-image :src="info.imgUrl" class="avatar">
          <div slot="error" class="image-slot">
            <i class="iconfont icon-tupian"></i>
          </div>
        </el-image>
        <p class="info">
          <span class="name">{{ info.salesName }}</span>
          <span class="identify">{{ info.salesPosition }}</span>
          <span class="sex">
            <i
              class="iconfont v"
              :class="info.sex === '1' ? 'icon-nan' : 'icon-nv'"
            />
            {{ info.sex | formatSex }}
          </span>
          <span class="phone">
            <i class="iconfont icon-dianhua" />
            {{ info.phone }}
          </span>
        </p>
        <div class="rt">
          <div class="intro table-wrapper" style="padding-bottom: 0">
            <span class="txt">提成比例：</span>
            <p class="ellipses">
              <span class="category">跨境</span>
              <span class="num">{{ info.crossRatio }}%</span>
            </p>
            <p class="ellipses">
              <span class="category black">完税</span>
              <span class="num">{{ info.dutyRatio }}%</span>
            </p>
          </div>
          <p class="intro">
            <span class="txt">归属商家：</span>
            <span class="merchant"> {{ info.merchantName }}</span>
          </p>
        </div>
      </div>
      <div class="box">
        <div class="item">
          <img class="img" src="../../../../assets/img/thirday.png" alt="" />
          <p class="money">
            {{ info.threeMonthSales | formatMoney }}
          </p>
        </div>
        <div class="item">
          <img class="img" src="../../../../assets/img/six.png" alt="" />
          <p class="money">
            {{ info.sixMonthSales | formatMoney }}
          </p>
        </div>
        <div class="item">
          <img class="img" src="../../../../assets/img/year.png" alt="" />
          <p class="money">
            {{ info.twelveMonthSales | formatMoney }}
          </p>
        </div>
      </div>
    </div>
    <div class="charts">
      <h3 class="title">{{ info.salesName }}销售数据</h3>
      <div class="filter">
        <el-date-picker
          @change="filterYear"
          class="select"
          v-model="year"
          type="year"
          format="yyyy年"
          value-format="yyyy"
          placeholder="按年"
        />
        <el-date-picker
          @change="filterMonth"
          class="select"
          v-model="month"
          type="month"
          format="yyyy年-MM月"
          value-format="yyyy-MM"
          placeholder="按月"
        />
        <el-button
          class="export fff-color"
          round
          v-permission:export="$route.meta.permission"
          >导出</el-button
        >
      </div>
      <div class="chart">
        <p class="top-tips">
          单位/元
        </p>
        <Histogram
          v-bind="$attrs"
          :dataZoom="dataZoom"
          :histogramData="chartData"
          :histogramSettings="histogramSettings"
          :colors="['#d5b68a']"
          height="35rem"
          :chartOptions="chartOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Histogram from 'components/Chart/histogram/'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('clerkInfo')
export default {
  name: 'clerkInfo',
  components: {
    Histogram
  },
  data() {
    this.histogramSettings = {}
    this.chartOptions = {
      barCategoryGap: '60%',
      yAxis: {
        axisLabel: {
          formatter: value => {
            return `￥${value}   `
          }
        }
      }
    }
    this.dataZoom = [
      {
        type: 'slider',
        start: 0,
        end: 100,
        backgroundColor: 'rgba(220, 196, 161, 0.2)',
        handleStyle: {
          color: 'rgba(220, 196, 161, 1)'
        },
        fillerColor: 'rgba(220, 196, 161, .3)'
      }
    ]
    this.keyMap = {
      sales_info: {
        name: 'chartData',
        date_time: '日期',
        order_amount: '销售额',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['日期', '销售额']
          }
        ]
      }
    }
    return {
      info: {},
      year: '',
      month: '',
      chartData: {}
    }
  },
  computed: {
    ...mapGetters(['getClerkInfo'])
  },
  created() {
    const id = this.$route.query.id
    this.info = this.getClerkInfo(id)
    this._getSalesData({
      sales_id: id,
      search_mode: 'month'
    })
  },
  methods: {
    /**
     * 获取数据
     * @param params
     * @private
     */
    _getSalesData(params) {
      this.api.getSalesData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartData = res.chartData
      })
    },
    /**
     * 按年筛选
     */
    filterYear() {
      this.month = ''
      this._getSalesData({
        sales_id: this.$route.query.id,
        year: this.year,
        search_mode: 'year'
      })
    },
    /**
     * 按月筛选
     */
    filterMonth() {
      this.year = ''
      const m = this.month.split('-')
      this._getSalesData({
        sales_id: this.$route.query.id,
        year: m[0],
        month: m[1],
        search_mode: 'month'
      })
    }
  }
}
</script>
<style lang="scss">
.clerk-info {
  .select {
    width: 9.3rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 1rem;
    border: solid 1px #34313a;

    &:nth-child(2) {
      margin-left: 2rem;
    }

    .el-input,
    .el-input__icon,
    .el-input__suffix-inner {
      height: 100%;
      line-height: 100%;
      color: #010101 !important;
    }

    input {
      background-color: transparent;
      height: 100%;
    }

    ::placeholder {
      color: #010101;
    }
  }

  .wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 1.3rem 0;

    .box {
      flex: 1;
      height: 18.8rem;
      background-color: #fff;
      display: flex;
      align-items: center;

      &:first-child {
        margin-right: 1.3rem;

        @include maxScreenWidth(1640) {
          margin-bottom: 1.3rem;
          margin-right: 0;
        }
      }

      @include maxScreenWidth(1640) {
        width: 100%;
        flex: initial;
      }
    }

    .avatar {
      width: 9.3rem;
      height: 9.3rem;
      border-radius: 50%;
      background-color: #f7f7f7;
      margin: 0 2.8rem 0 3.1rem;
    }

    .name {
      font-size: 1.3rem;
      font-weight: bold;
    }

    .info {
      margin-right: 1rem;
      span {
        display: block;
      }
    }

    .icon-nv {
      color: colors('bg-sub');
    }

    .icon-dianhua {
      color: rgb(103, 176, 69);
    }

    .sex {
      margin-bottom: 0.1rem;
    }

    .identify {
      margin-bottom: 1.3rem;
    }

    .percent {
      display: inline-block;
      vertical-align: middle;
      width: 3.8rem;
      height: 3.8rem;
      line-height: 3.8rem;
      text-align: center;
      background-color: colors('bg-sub');
      border-radius: 50%;
      color: #fff;
    }

    .merchant {
      display: inline-block;
      vertical-align: sub;
      font-size: 1.3rem;
      font-weight: bold;
      white-space: nowrap;
    }

    .item {
      margin: 0 auto;
      text-align: center;
    }

    .img {
      width: 59px;
      height: 64px;
      margin-bottom: 2.1rem;
    }

    .money {
      font-size: 1.3rem;
      font-weight: bold;
    }
  }

  .charts {
    background-color: #fff;
    min-height: 46rem;
    padding: 4rem 3.4rem;

    .title {
      font-size: 1.2rem;
      text-align: center;
      margin-bottom: 2.8rem;
    }

    .filter {
      position: relative;
      text-align: center;
    }

    .export {
      position: absolute;
      right: 0;
      width: 6.3rem;
      height: 2rem;
      padding: 0;
    }
  }
  .table-wrapper {
    display: flex;
    .num {
      width: initial;
      margin-right: 10px;
    }
  }
}
</style>
